import { Col, Divider, InputNumber, Row, Space } from "antd";
import { CSSProperties, FC, useCallback, useMemo } from "react";
import { Matrix4x3 } from "./use-position-data-helper";

export interface PositionDataMatrixParams {
  data: Matrix4x3 | undefined;
}

export const PositionDataMatrix: FC<PositionDataMatrixParams> = ({ data }) => {
  const disabled = useMemo(() => data === undefined, [data]);
  const style: CSSProperties = useMemo(() => ({ textAlign: "center" }), []);

  const setXX = useCallback((value: number | null) => value !== null && data?.setXX(value), [data]);
  const setXY = useCallback((value: number | null) => value !== null && data?.setXY(value), [data]);
  const setXZ = useCallback((value: number | null) => value !== null && data?.setXZ(value), [data]);
  const setYX = useCallback((value: number | null) => value !== null && data?.setYX(value), [data]);
  const setYY = useCallback((value: number | null) => value !== null && data?.setYY(value), [data]);
  const setYZ = useCallback((value: number | null) => value !== null && data?.setYZ(value), [data]);
  const setZX = useCallback((value: number | null) => value !== null && data?.setZX(value), [data]);
  const setZY = useCallback((value: number | null) => value !== null && data?.setZY(value), [data]);
  const setZZ = useCallback((value: number | null) => value !== null && data?.setZZ(value), [data]);
  const setTX = useCallback((value: number | null) => value !== null && data?.setTX(value), [data]);
  const setTY = useCallback((value: number | null) => value !== null && data?.setTY(value), [data]);
  const setTZ = useCallback((value: number | null) => value !== null && data?.setTZ(value), [data]);

  return (
    <>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Row align="middle">
          <Col span={1}>XX</Col>
          <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.xx} onChange={setXX} min={-1} max={1}/></Col>
          <Col span={4} push={3}>XY</Col>
          <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.xy} onChange={setXY} min={-1} max={1}/></Col>
          <Col span={4} push={3}>XZ</Col>
          <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.xz} onChange={setXZ} min={-1} max={1}/></Col>
        </Row>
        <Row align="middle">
          <Col span={1}>YX</Col>
          <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.yx} onChange={setYX} min={-1} max={1}/></Col>
          <Col span={4} push={3}>YY</Col>
          <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.yy} onChange={setYY} min={-1} max={1}/></Col>
          <Col span={4} push={3}>YZ</Col>
          <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.yz} onChange={setYZ} min={-1} max={1}/></Col>
        </Row>
        <Row align="middle">
          <Col span={1}>ZX</Col>
          <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.zx} onChange={setZX} min={-1} max={1}/></Col>
          <Col span={4} push={3}>ZY</Col>
          <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.zy} onChange={setZY} min={-1} max={1}/></Col>
          <Col span={4} push={3}>ZZ</Col>
          <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.zz} onChange={setZZ} min={-1} max={1}/></Col>
        </Row>
      </Space>
      <Divider/>
      <Row align="middle">
        <Col span={1}>TX</Col>
        <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.tx} onChange={setTX}/></Col>
        <Col span={4} push={3}>TY</Col>
        <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.ty} onChange={setTY}/></Col>
        <Col span={4} push={3}>TZ</Col>
        <Col span={5}><InputNumber disabled={disabled} style={style} value={data?.tz} onChange={setTZ}/></Col>
      </Row>
    </>
  );
};
